<template>
  <div>
    <v-list dense>
      <v-list-item to="/">
        <v-list-item-action>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('message.menu.title.availableServices') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/account/change">
        <v-list-item-action>
          <v-icon>mdi-account-edit</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('message.menu.title.changeAccountInfo') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list
      subheader
      dense
      v-if="$store.getters.isGroupAdminFlg"
    >
      <v-subheader>{{ $t('message.menu.title.subMenuGroupAdmin') }}</v-subheader>
      <v-list-item to="/group/account/list">
        <v-list-item-action>
          <v-icon>mdi-account-cog</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('message.menu.title.manageAccount') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/group/account/entry/list">
        <v-list-item-action>
          <v-icon>mdi-account-check</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('message.menu.title.acceptAccountEntry') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list
      subheader
      dense
      v-if="$store.getters.isAdminFlg"
    >
      <v-subheader>{{ $t('message.menu.title.subMenuAdmin') }}</v-subheader>
      <v-list-item to="/admin/account/list">
        <v-list-item-action>
          <v-icon>mdi-account-cog</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('message.menu.title.manageAccountAdmin') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/admin/account/changegroup">
        <v-list-item-action>
          <v-icon>mdi-account-cog</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('message.menu.title.accountChangeGroup') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/admin/account/entry/list">
        <v-list-item-action>
          <v-icon>mdi-account-check</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('message.menu.title.acceptAccountEntryAdmin') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/admin/account/service/application/list">
        <v-list-item-action>
          <v-icon>mdi-account-check</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('message.menu.title.acceptAccountServiceApplicationAdmin') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/admin/mst/group/list">
        <v-list-item-action>
          <v-icon>mdi-settings</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('message.menu.title.manageGroups') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/admin/mst/company/list">
        <v-list-item-action>
          <v-icon>mdi-settings</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('message.menu.title.manageCompany') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/admin/mst/service/list">
        <v-list-item-action>
          <v-icon>mdi-settings</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('message.menu.title.manageServices') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/admin/sendmail">
        <v-list-item-action>
          <v-icon>mdi-settings</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('message.menu.title.sendMail') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  props: {},
  data: () => ({}),
  computed: {
  }
}
</script>
